import React, { useState } from "react";
import { Container, Row, Col, Carousel, Image } from "react-bootstrap";
import { motion } from "framer-motion";
import { FiPhoneCall } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";

// Common layout components
import CustomNavbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

import "./MedicalProduct.css";

function MedicalProducts() {
  const products = [
    { id: 1, name: "Piles Cure Kit", img: "./products/Abhyang-kit.jpeg", desc: "Ayurvedic kit for piles relief and digestive health." },
    { id: 2, name: "Abhyang Kit", img: "./products/Abhyang-kit.jpeg", desc: "Body rejuvenation with natural oils and herbs." },
    { id: 3, name: "Hair Regrowth Kit", img: "./products/Abhyang_kit.jpeg", desc: "Nourishing oils and serums for hair strength and shine." },
    { id: 4, name: "Detox Kit", img: "./products/Abhyang_kit.jpeg", desc: "Cleanse your body naturally with herbal detox formula." },
    { id: 5, name: "Skin Glow Kit", img: "./products/Abhyang_kit.jpeg", desc: "Brightening and moisturizing skincare combo." },
  ];

  const events = [
    { id: 101, name: "Health Camp 2025", img: "./events/health-camp.jpg", desc: "Free medical checkup and consultation." },
    { id: 102, name: "Ayurveda Awareness Week", img: "./events/ayurveda-week.jpg", desc: "Workshops and special offers on wellness." },
  ];

  const allSlides = [...products, ...events];
  const [selectedIndex, setSelectedIndex] = useState(0);

  const phoneNumber = "+919876543210";
  const whatsappNumber = "919876543210";

  const openWhatsApp = (productName) => {
    const message = encodeURIComponent(`Hello! I am interested in buying the "${productName}". Please share more details.`);
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <>
      <CustomNavbar />

      <section className="medical-products-section py-5">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-4"
          >
            <h2 className="fw-bold text-uppercase">Medical Products & Events</h2>
            <p className="text-muted">Explore our health kits and upcoming wellness programs.</p>
          </motion.div>

          <Row className="justify-content-center mb-5">
  <Col md={10} lg={8}>
    <div className="carousel-wrapper">
      <Carousel
        activeIndex={selectedIndex}
        onSelect={(i) => setSelectedIndex(i)}
        interval={4000}
        className="custom-carousel"
      >
        {allSlides.map((item, i) => (
          <Carousel.Item key={i}>
            <Image
              src={item.img}
              alt={item.name}
              className="carousel-image"
            />
            <Carousel.Caption className=" bg-opacity-50 rounded">
              {/* <h5>{item.name}</h5>
              <p>{item.desc}</p> */}

              {/* Contact Icons */}
              <div className="d-flex justify-content-between gap-3 mt-3">
                <motion.a
                  whileHover={{ scale: 1.1 }}
                  href={`tel:${phoneNumber}`}
                  className="contact-icon call-icon"
                  title="Call Clinic"
                >
                  <FiPhoneCall />
                </motion.a>

                <motion.a
                  whileHover={{ scale: 1.1 }}
                  onClick={() => openWhatsApp(item.name)}
                  className="contact-icon whatsapp-icon"
                  title="Chat on WhatsApp"
                >
                  <FaWhatsapp />
                </motion.a>
              </div>
            </Carousel.Caption>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  </Col>
</Row>

          {/* Product Thumbnails */}
          <Row xs={2} sm={3} md={4} lg={5} className="g-3 text-center">
            {allSlides.map((item, i) => (
              <Col key={i}>
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  onClick={() => setSelectedIndex(i)}
                  className={`product-thumb p-2 rounded shadow-sm ${
                    selectedIndex === i ? "active-thumb" : ""
                  }`}
                >
                  <Image src={item.img} alt={item.name} thumbnail className="rounded square-img" />
                  <p className="mt-2 mb-0 small fw-semibold">{item.name}</p>
                </motion.div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
}

export default MedicalProducts;
